import {useState, useEffect} from 'react'
import {ShellPremiumClubReport} from "./ShellPremiumClubReport/ShellPremiumClubReport"
import {ShellPremiumClubName} from "./MarketingStockReportName"
export const MarketingStockReportWrapper = ({reportModel}) => {

    const [stockReportComponent, setStockReportComponent] = useState(null);

    useEffect(() => {
        selectReportComponent();
    }, [reportModel])

    const selectReportComponent = () => {
        if(reportModel === null){
            return;
        }

        switch(reportModel.ReportName){
            case ShellPremiumClubName:
                const component = <ShellPremiumClubReport reportObject={reportModel.ReportObject}/>
                setStockReportComponent(component)
                break;
            
            default:
                setStockReportComponent(null)
                break;
        }
    }

    if(reportModel === null || reportModel.ReportObject.length === 0)
    {
        return null
    }


    return (
        <div style={{padding:'0px'}}>
            {stockReportComponent}
        </div>
    )
}